import React from "react";
import styles from "./LoaderSpinner.module.scss";

interface LoaderSpinnerProps {
  className?: string;
}

const LoaderSpinner: React.FC<LoaderSpinnerProps> = ({ className }) => {
  return (
    <div className={`${styles.spinnerContainer} ${className || ""}`}>
      <div className={styles.spinner}></div>
    </div>
  );
};

export default LoaderSpinner;
